import { PageStatus, ValidationErrorData } from '../../typings/common';
import { FeedFilterRateType } from '../../typings/feedFilters';

export interface ChangeFeedFilterRatePayload {
    rateType?: FeedFilterRateType;
    rate?: number;
}

export const CHANGE_FEED_FILTERS_RATE = 'CHANGE_FEED_FILTERS_RATE';
export type CHANGE_FEED_FILTERS_RATE = typeof CHANGE_FEED_FILTERS_RATE;

export interface ChangeFeedFiltersRateAction {
    type: CHANGE_FEED_FILTERS_RATE;
    payload: ChangeFeedFilterRatePayload;
}

export function changeFeedFiltersRate(
    payload: ChangeFeedFilterRatePayload
): ChangeFeedFiltersRateAction {
    return {
        type: CHANGE_FEED_FILTERS_RATE,
        payload
    };
}

export const UPDATE_FEED_FILTERS_RATE = 'UPDATE_FEED_FILTERS_RATE';
export type UPDATE_FEED_FILTERS_RATE = typeof UPDATE_FEED_FILTERS_RATE;

export interface UpdateFeedFiltersRateAction {
    type: UPDATE_FEED_FILTERS_RATE;
    filtersIds: Array<string>;
    rateType: FeedFilterRateType;
    rate?: number;
}

export function updateFeedFiltersRate(
    filtersIds: Array<string>,
    rateType: FeedFilterRateType,
    rate?: number
): UpdateFeedFiltersRateAction {
    return {
        type: UPDATE_FEED_FILTERS_RATE,
        filtersIds,
        rateType,
        rate
    };
}

export const UPDATE_FEED_FILTERS_RATE_RESULT =
    'UPDATE_FEED_FILTERS_RATE_RESULT';
export type UPDATE_FEED_FILTERS_RATE_RESULT = typeof UPDATE_FEED_FILTERS_RATE_RESULT;

export interface UpdateFeedFiltersRateResultAction {
    type: UPDATE_FEED_FILTERS_RATE_RESULT;
    status: PageStatus;
}

export function updateFeedFiltersRateResult(
    status: PageStatus
): UpdateFeedFiltersRateResultAction {
    return {
        type: UPDATE_FEED_FILTERS_RATE_RESULT,
        status
    };
}

export const SET_FEED_FILTER_RATE_FORM_ERRORS =
    'SET_FEED_FILTER_RATE_FORM_ERRORS';
export type SET_FEED_FILTER_RATE_FORM_ERRORS = typeof SET_FEED_FILTER_RATE_FORM_ERRORS;

export interface SetFeedFilterRateFormErrorsAction {
    type: SET_FEED_FILTER_RATE_FORM_ERRORS;
    errors: Array<ValidationErrorData>;
}

export function setFeedFilterRateFormErrors(
    errors: Array<ValidationErrorData>
): SetFeedFilterRateFormErrorsAction {
    return {
        type: SET_FEED_FILTER_RATE_FORM_ERRORS,
        errors
    };
}

export type FeedFilterChangeRateModalAction =
    | ChangeFeedFiltersRateAction
    | UpdateFeedFiltersRateAction
    | UpdateFeedFiltersRateResultAction
    | SetFeedFilterRateFormErrorsAction;
